import { render, staticRenderFns } from "./MonitorParagraphObjectCreate.vue?vue&type=template&id=1d7f4a00&"
import script from "./MonitorParagraphObjectCreate.vue?vue&type=script&lang=js&"
export * from "./MonitorParagraphObjectCreate.vue?vue&type=script&lang=js&"
import style0 from "./MonitorParagraphObjectCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports